
const About = () => {
    return (
        <div>Still working on the about page!</div>
    )
}

export default About;